import React from 'react';
import PropTypes from 'prop-types';
import MineralUiButton from 'mineral-ui/Button';
import styled from '@emotion/styled';
import { FaWindowClose } from 'react-icons/fa';

const propTypes = {
  children: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
};

const ChipBox = styled.div`
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  border-radius: .8em;
  background-color: ${props => props.theme.backgroundColor_themePrimary};
  padding-left: .4em;
  color: white;
`;

const ChipText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: small;
`;

const Button = styled(MineralUiButton)({
  display: 'block',
  height: '2em',
  width: '2em',
  marginLeft: '.3em',
});


function Chip({
  children,
  onRemove,
}) {
  return (
    <ChipBox>
      <ChipText>
        {children}
      </ChipText>
      <Button
        iconStart={<FaWindowClose />}
        onClick={onRemove}
        circular
        primary
      />
    </ChipBox>
  );
}
Chip.propTypes = propTypes;
export default Chip;
